"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _q = _interopRequireDefault(require("q"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var I18n = _interopRequireWildcard(require("I18n"));

var _UIApplication = _interopRequireDefault(require("UIComponents/app/UIApplication"));

var _reactRedux = require("react-redux");

var _store = _interopRequireDefault(require("pricing-pages-unified-ui/utils/store"));

var _ConfigActions = require("pricing-pages-unified-ui/actions/ConfigActions");

var _reactRouterDom = require("react-router-dom");

var _reactRhumb = require("react-rhumb");

var _historyAdapterV = _interopRequireDefault(require("react-rhumb/historyAdapterV4"));

var _rhumbConfig = _interopRequireDefault(require("../rhumb-config.yaml"));

var _history = require("history");

var _Routes = _interopRequireDefault(require("./Routes"));

var _Raven = _interopRequireDefault(require("Raven"));

var _usageTrackerContainer = require("usage-tracker-container");

var _ErrorPage = _interopRequireDefault(require("pricing-pages-unified-ui/components/ErrorPage"));

var _getFormattedExperimentArray = require("pricing-pages-unified-ui/utils/getFormattedExperimentArray");

var _getUsageTracker = _interopRequireDefault(require("./utils/getUsageTracker"));

var _handlers = require("q/js/handlers");

var _isThenable = _interopRequireDefault(require("hs-promise-utils/isThenable"));

var _PurchaseMotionActions = require("pricing-pages-unified-ui/actions/PurchaseMotionActions");

var _PublicAuthApi = require("pricing-pages-unified-ui/api/public-only/PublicAuthApi");

// Redux
// Router
// Other
// Other
// Log and alert both Q `.done()` rejections _and_ unhandled errors (via polled interval)
(0, _handlers.logQPromiseIssuesAndSendAlerts)();
var dispatch = _store.default.dispatch; // Actions for bootstrapping

var whenIdle = function whenIdle(cb) {
  if (window.hasOwnProperty('requestIdleCallback')) {
    window.requestIdleCallback(cb);
  } else {
    setTimeout(cb, 0);
  }
};

var App =
/*#__PURE__*/
function () {
  function App(config) {
    (0, _classCallCheck2.default)(this, App);
    this.config = config;
  } // Kicks off the app. This is intentionally not in the constructor.


  (0, _createClass2.default)(App, [{
    key: "start",
    value: function start() {
      var _this = this;

      console.log('PublicApp#start(), config: ', this.config);
      (0, _usageTrackerContainer.setPrimaryTracker)(this.config.tracker);
      var history = (0, _history.createBrowserHistory)({
        basename: this.config.rootUrl
      });
      var bootstrapBlockingPromises = this.fetchBootstrapBlockers(history);

      _q.default.Promise.all([].concat((0, _toConsumableArray2.default)(bootstrapBlockingPromises), [I18n.Info])).then(function () {
        _this.startRouter(history);

        _this.trackRedirectableUsers();
      }).catch(function (error) {
        // No guarantee yet that I18n finished since another
        // promise could have rejected earlier
        I18n.Info.then(function () {
          // We chain our bootstrapping code with this catch
          // so we can show an Error screen rather than just a blank page
          // A side effect of this is that any errors that bubble up here
          // would be swallowed up unless we re-throw.
          _this.startRouter(history, true);

          _Raven.default.captureMessage('Failed to bootstrap public app', {
            extra: {
              error: error
            }
          });

          _this.trackRedirectableUsers();
        });
      });
    }
  }, {
    key: "trackRedirectableUsers",
    value: function trackRedirectableUsers() {
      var _this2 = this;

      whenIdle(function () {
        (0, _PublicAuthApi.fetchAuth)().then(function () {
          _this2.config.tracker.track('pageView', {
            screen: 'public redirect',
            subscreen: 'authed'
          });
        }).catch(function () {
          _this2.config.tracker.track('pageView', {
            screen: 'public redirect',
            subscreen: 'unauthed'
          });
        });
      });
    }
  }, {
    key: "fetchBootstrapBlockers",
    value: function fetchBootstrapBlockers(history) {
      if (!history) {
        throw new Error("cannot bootstrap without history");
      }

      var promises = [];
      this.config.blockingRequests.forEach(function (blockingCall) {
        /*
         * Potential return value(s) of a blockingCall() include:
         *
         *   1. A promise
         *   2. A thunk action creator
         */
        var promise = blockingCall(); // Non-promises assumed to be thunk action creators

        if (!(0, _isThenable.default)(promise)) {
          // Wrap in dispatch for thunk middleware to take effect
          promise = dispatch(promise);
        }

        promises.push(promise);
      });
      promises.push(dispatch((0, _ConfigActions.storeEnvironmentConfig)(this.config)));
      return promises;
    }
  }, {
    key: "fetchPricingAndPurchasingData",
    value: function fetchPricingAndPurchasingData() {
      var promises = [];
      promises.push(dispatch((0, _PurchaseMotionActions.fetchPurchaseMotionData)(this.config.getPurchaseMotions)).catch(console.error));
      promises.push(dispatch((0, _PurchaseMotionActions.fetchMerchandiseCatalog)()).catch(console.error));
      return promises;
    }
  }, {
    key: "addChatTrackingEventHandler",
    value: function addChatTrackingEventHandler() {
      window.HubSpotConversations.on('conversationStarted', function (payload) {
        // Assumes experiment treatments are fetched by now. May not
        // be 100% correct for lazy loaded experiments, but probably
        // fine since this requires user interaction to fire and gives
        // enough time
        var formattedExperimentArray = (0, _getFormattedExperimentArray.getFormattedExperimentArray)(_store.default.getState().experimentTreatments);
        (0, _getUsageTracker.default)().track('conversations', {
          action: 'conversation-started',
          formattedExperimentArray: formattedExperimentArray,
          conversationId: payload.conversation.conversationId
        });
      });
    }
  }, {
    key: "setupChatTracking",
    value: function setupChatTracking() {
      var _this3 = this;

      if (window.HubSpotConversations) {
        this.addChatTrackingEventHandler();
      } else {
        window.hsConversationsOnReady = [function () {
          _this3.addChatTrackingEventHandler();
        }];
      }
    }
  }, {
    key: "startRouter",
    value: function startRouter(history) {
      var hasError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.fetchPricingAndPurchasingData();
      this.setupChatTracking();
      (0, _reactDom.render)(_react.default.createElement(_UIApplication.default, {
        name: "pricing-pages-unified-ui",
        className: "public-pricing-page"
      }, _react.default.createElement(_reactRedux.Provider, {
        store: _store.default
      }, _react.default.createElement(_reactRhumb.RhumbProvider, {
        history: (0, _historyAdapterV.default)(history),
        config: _rhumbConfig.default
      }, _react.default.createElement(_reactRouterDom.Router, {
        history: history
      }, hasError ? _react.default.createElement(_ErrorPage.default, null) : _react.default.createElement(_Routes.default, {
        defaultRoute: {
          search: history.location.search,
          pathname: this.config.defaultHubRoute
        }
      }))))), document.getElementsByClassName('page')[0]);
    }
  }]);
  return App;
}();

exports.default = App;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/PublicApp.js
// module id = 961
// module chunks = 6